module.exports = __webpack_public_path__ + "img/3.46f45623.jpg";